module.exports = __webpack_public_path__ + "VAGRoundedStd-Black.043f85411799a4ce7ace.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Black.woff2
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Black.woff2
// module chunks = styles